<template>
  <div class="columnlistBox">
    <div v-for="(item,index) in columnlist" :key="index" class="column_li">
      <lisTemplatevdo v-if="isvdo" :list="item" />
      <lisTemplate3 v-else :list="item" />
      <!--<a v-show="isvdo" class="vdoIMG" :href="'/Detail?contentId='+item.CONTENT_ID" target="_blank" />-->
    </div>
  </div>
</template>
<script>
import lisTemplate3 from '@/components/centerlist_atlas/listTemplate3/index.vue'
import lisTemplatevdo from '@/components/lisTemplateVdo/index.vue'
export default {
  components: { lisTemplate3, lisTemplatevdo },
  props: ['columnlist', 'isvdo'],
  data() {
    return {
    }
  },
  methods: {
    goDetail: function(contentId) {
      const { href } = this.$router.resolve({
        path: '/Detail',
        name: 'dt',
        query: {
          contentId
        }
      })
      window.open(href, '_blank')
    }
  }

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .columnlistBox{
        margin-top: 20px;
        overflow: hidden;
         background-color: #fff;
        .column_li{
          /*background-color: #fff;*/
            width: 267px;
            display: inline-block;
            float: left;
            margin-right:39px;
            margin-bottom: 20px;
            position: relative;
            transition: 0.3s;
          &:hover{
            transform: translate(0,-3px);
          }
          .vdoIMG{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            border: 3px solid rgba(249,245,246,.5);
            position: absolute;
            top: 100px;
            left: 105px;
            cursor: pointer;
          }
          .vdoIMG::after{
            content: '';
            display: block;
            position: absolute;
            top: 13px;
            left: 15px;
            width: 0;
            height: 0;
            border-top: 12px solid transparent;
            border-bottom:  12px solid transparent;
            border-left:20px solid rgba(247,247,247,.5);
          }
        }

    }
    .column_li:nth-child(3n){
      margin-right: 0;
    }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .columnlistBox .column_li .vdoIMG{
      top:calc(50% - 31px);
      left:calc(50% - 37px);
    }
    .columnlistBox {
      margin-top: 0;
      padding:  20px;
      .column_li{
        float: none;
        margin: 0 auto 20px;
        width: 100%;
        border-bottom: 1px solid #eee;
      }
    }
  }
</style>
